class Nav
{
    constructor()
    {
		this.match = gsap.matchMedia();
		this.menuToggle = document.querySelector(".menu-toggle");
		this.menu = document.querySelector(".menu-overlay");
		this.currentScroll = 0;		
		this.init();
    }

    init()
	{
		document.addEventListener('click', (e) => this.onAnchorClick(e));

		if(window.location.hash) {
			const elementId = window.location.hash.substring(1);
			this.scrollToElementById(elementId);
		}

		window.addEventListener("hashchange", (e) =>
		{
			if(this.menu && this.menu.classList.contains("active")) {
				this.closeMenu();
				this.menu.classList.toggle("active");
			}
			const elementId = window.location.hash.substring(1);
			this.scrollToElementById(elementId);
		});

		if (this.menuToggle && this.menu) {
			this.menuToggle.addEventListener("mouseenter", (e) => this.onEnterMenu(e));
			this.menuToggle.addEventListener("mouseleave", (e) => this.onLeaveMenu(e));
			this.menuToggle.addEventListener("click", (e) => this.onToggleMenu(e));
		}
	}

	onAnchorClick(e) {
		if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
		const link = e.target.closest('a');
		if (!link || link.target === '_blank') return;

		const href = link.getAttribute('href');
		if (!href || href === '#') return;

		let url;
		try {
			url = new URL(link.href, window.location.href);
		} catch (err) {
			return;
		}
		if (!url.hash || url.hash === '#') return;
		if (url.origin !== window.location.origin) return;

		const path = (value) => value.replace(/\/+$/, '') || '/';
		if (path(url.pathname) !== path(window.location.pathname)) return;

		const id = decodeURIComponent(url.hash.slice(1));
		if (!document.getElementById(id)) return;

		e.preventDefault();
		const menuOpen = this.menu && this.menu.classList.contains('active');
		if (menuOpen) {
			this.closeMenu();
			this.menu.classList.toggle('active');
		}
		if (window.location.hash !== '#' + id) {
			history.pushState(null, '', '#' + id);
		}
		this.scrollToElementById(id, menuOpen ? 350 : 0);
	}

	scrollToElementById(id, delay = 300) {
		setTimeout(() => {
			const element = document.getElementById(id);
			if (!element) return;

			const lenis = window.guildeLenis;
			if (lenis && typeof lenis.scrollTo === 'function') {
				lenis.scrollTo(element, {
					offset: -100,
					duration: 0.7,
					force: true,
				});
				return;
			}

			const top = element.getBoundingClientRect().top + window.scrollY - 100;
			window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
		}, delay);
	}

	onEnterMenu(e)
	{
		if(!this.menu.classList.contains("active")) {
			this.menuToggle.classList.toggle("over");
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration:0.15, width:20, rotation:90, x:-7, y:0, ease:"power3.out"});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, width:20, y:0, x:-7, ease:"power3.out"});
		}
	}

	onLeaveMenu(e)
	{
		if(!this.menu.classList.contains("active")) {
			this.menuToggle.classList.toggle("over");
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration:0.15, width:37, rotation:0, x:0, y:5, ease:"power3.out"});
			gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, width:37, y:-5, x:0, ease:"power3.out"});
		}
	}

	onToggleMenu(e)
	{
		if(!this.menu.classList.contains("moving")) {
			
			this.menu.classList.add("moving");

			if(!this.menu.classList.contains("active")) {

				// Ouverture du menu

				this.currentScroll = window.scrollY;
				gsap.set('body', {"position":"fixed", "overflow-y":"scroll", "width":"100%"});

				gsap.to("header", {mixBlendMode:"normal", duration:0.4});

				if(!this.menuToggle.classList.contains("over")) {
					this.menuToggle.classList.toggle("over");
					gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:first-child"), {duration:0.15, width:20, rotation:90, x:-7, y:1, ease:"power3.out"});
					gsap.to(this.menuToggle.querySelector(".menu-toggle-bar:last-child"), {duration:0.15, width:20, y:1, x:-7, ease:"power3.out"});
				}

				gsap.to(this.menu, {duration:0.4, visibility:"visible", pointerEvents:"all", alpha:1, ease:"power3.out"});
				gsap.to(this.menuToggle, {duration:0.2, rotation:45, x:2, y:-1, ease:"power3.out"});

				gsap.set(".menu-fiche-container", {alpha:1, x:0, rotationY:0, transformStyle: "preserve-3d", transformOrigin: "0% 50%"});
				gsap.from(".menu-fiche-container", {
					autoAlpha:0,
					duration:1,
					x:50,
					z:0,
					rotationY: 20, 
					ease:"power3.out",
					delay:0.1,
					onComplete:()=>this.menu.classList.remove("moving")
				});

				gsap.set("nav:first-child li", {alpha:1, y:0});
				gsap.from("nav:first-child li", {
					autoAlpha:0,
					duration:0.8,
					y:30,
					ease:"power3.out",
					stagger:0.05,
					delay:0.1
				});

				gsap.set("nav:nth-child(2) li", {alpha:1, y:0});
				gsap.from("nav:nth-child(2) li", {
					autoAlpha:0,
					duration:1,
					y:30,
					ease:"power3.out",
					stagger:0.05,
					delay:0.55
				});

				this.match.add("(max-width: 768px)", () => {
					gsap.set(".menu-overlay nav:last-child li", {alpha:1, y:0});
					gsap.from(".menu-overlay nav:last-child li", {
						autoAlpha:0,
						duration:1,
						y:30,
						ease:"power3.out",
						stagger:0.05,
						delay:0.7
					});
				});
				
			} else {

				// Fermeture du menu
				this.closeMenu();

			}

			this.menu.classList.toggle("active");
		}
	}

	closeMenu()
	{
		gsap.set('body', {"position":"", "overflow-y":"", "width":""});
		window.scrollTo(0, this.currentScroll);

		gsap.to(".menu-fiche-container", {
			duration:0.4,
			x:30,
			alpha:0,
			rotationY: 10, 
			ease:"power2.in",
			overwrite:true
		});

		gsap.to(".menu-overlay nav:first-child li", {
			alpha:0,
			duration:0.2,
			ease:"power2.in",
			stagger:0.03,
		});

		gsap.to(".menu-overlay nav:nth-child(2) li", {
			alpha:0,
			duration:0.2,
			ease:"power2.in",
			stagger:0.03,
			delay:0.2
		});

		this.match.add("(max-width: 768px)", () => {
			gsap.to(".menu-overlay nav:last-child li", {
				alpha:0,
				duration:0.2,
				ease:"power2.in",
				stagger:0.03,
				delay:0.25
			});
		});

		gsap.to(this.menu, {delay:0.4, duration:0.5, visibility:"hidden", pointerEvents:"none", alpha:0, ease:"power3.out", onComplete:() =>
		{
			this.menu.classList.remove("moving");
			//if(window.scrollY > 100) {
				gsap.to("header", {alpha:0, duration:0.2, onComplete:()=>
				{
					gsap.set("header", {mixBlendMode:"exclusion"});
					gsap.to("header", {alpha:1, duration:0.8, ease:"expo.out"});
				}});
			//}
		}});

		gsap.to(this.menuToggle, {duration:0.2, rotation:0, x:0, y:0, ease:"power3.out"});
	}
}

export default Nav;